(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["map-home"] && !Shopify.designMode) return;
  try {
    

window.onload = function(){
$( ".lista_ciudades" ).click(function() {
return;
});
var ciudades = ["BOGOTA", "BARRANQUILLA", "MEDELLIN", "CALI"];
$(".lista_ciudades").on('click','li',function () {
return;
});

// declare variable
var topmapa = $(".scrollTop");

$(window).scroll(function() {
    // declare variable
    var topPos = $(this).scrollTop();
}); // scroll END

//Click event to scroll to top
$(topmapa).click(function() {
    alert("hols");
    $('html, body').animate({
        scrollTop: 3350
    }, 800);
    return false;
}); // click() scroll top EMD

};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["register-home"] && !Shopify.designMode) return;
  try {
    
window.scrollTo({ top: 0 });

  } catch(e) { console.error(e); }
})();
})();
